if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
            
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
            setTimeout(function () {
              Rebuy.init();
            }, 1000);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}


// Subscription JS 

// document.addEventListener("DOMContentLoaded", function () { 
//   const subscription = document.querySelector(".custom-subscription");
//    if (!subscription) return;
//   const options = document.querySelectorAll(".frequency-box .option");
//   const frequencyBox = document.querySelector(".frequency-buttons");
//   const bundleBox = document.querySelector(".bundle_offer_option");
//   const hiddenInput = document.querySelector("input[name='selling_plan']");
//   const frequencyLabels = document.querySelectorAll(".frequency-label");

//   // Hide frequency initially if onetime and Bundle is selected
// // Initial display based on "active" class
// if (document.querySelector(".option.onetime input.active")) {
//   // frequencyBox.style.display = "none";
//   // bundleBox.style.display = "none";
// }

// if (document.querySelector(".option.bundle input.active")) {
//   // frequencyBox.style.display = "none";
//   // bundleBox.style.display = "block";
// }

// if (document.querySelector(".option.subscription input.active")) {
//   // bundleBox.style.display = "none";
//   // frequencyBox.style.display = "flex";
// }
//   // Option click handler


//     options.forEach(option => {
//     const label = option.querySelector("label");
//     if (!label) return;

//     label.addEventListener("click", function (e) {
//       e.stopPropagation(); // prevent bubbling to parent div

//       const type = option.getAttribute("data-purchase-option");

//       // Update radio
//       options.forEach(o => o.querySelector("input[type='radio']").classList.remove("active"));
//       const radio = label.querySelector("input[type='radio']");
//       if (radio) radio.classList.add('active');

//       if (type === "subscription") {
//         // frequencyBox.style.display = "flex";
//         // bundleBox.style.display = "none";

//         const activeFrequency = document.querySelector(".frequency-label.active");
//         if (activeFrequency) {
//           hiddenInput.value = activeFrequency.getAttribute("value");
//         }
//       } else if (type === "bundle") {
//         // frequencyBox.style.display = "none";
//         // bundleBox.style.display = "block"; 
//         hiddenInput.value = ""; 
//       } else { // onetime
//         // frequencyBox.style.display = "none";
//         // bundleBox.style.display = "none";
//         hiddenInput.value = ""; 
//       }
//     });
//   });

//   // Frequency label click handler
//   frequencyLabels.forEach(label => {
//     label.addEventListener("click", function () {
//       // Remove active from all frequency labels and add to clicked
//       frequencyLabels.forEach(l => l.classList.remove("active"));
//       this.classList.add("active");

//       // Update hidden input value
//       hiddenInput.value = this.getAttribute("value");

//       // Automatically select the subscription option
//       const subscriptionOption = document.querySelector(".option.subscription");
//       if (subscriptionOption) {
//         const radio = subscriptionOption.querySelector("input[type='radio']");
//         if (radio && !radio.classList.contains("active")) {
//           // Remove active from all other radios
//           document.querySelectorAll(".frequency-box .option input[type='radio']").forEach(r => r.classList.remove("active"));
//           radio.classList.add("active");
//         }

//         // Optional: if you want frequency box displayed
//         const frequencyBox = document.querySelector(".frequency-buttons");
//         const bundleBox = document.querySelector(".bundle_offer_option");
//       }
//     });
//   });
// });

// const bundleOption = document.querySelector(".option.bundle");
// if (bundleOption) {
//   const bundleRadio = bundleOption.querySelector("input[type='radio']");

//   bundleOption.addEventListener("click", function () {
//     if (bundleRadio) {
//       // Remove active from all other radios
//       document.querySelectorAll(".frequency-box .option input[type='radio']").forEach(r => r.classList.remove("active"));
//       bundleRadio.classList.add("active");
//     }
//     // Clear hidden input since bundle may not need frequency
//     hiddenInput.value = "";
//   });
// }